<template>
  <div>
    <PageHeader
      current-app="online-video"
    />
    <SubNav />
    <router-view />
    <div
      v-if="visibleBanner"
      id="cb-cookie-banner"
      class="alert alert-dark text-center mb-0 banner browserWarning"
      role="alert"
    >
      NOTE: This tool is optimized for Chrome browser

      <button
        type="button"
        class="btn btn-primary btn-sm ms-3 browserBannerBtn"
        @click="hideBrowserBanner()"
      >
        OK
      </button>
    </div>
  </div>
</template>

<script>
import PageHeader from "./PageHeader/PageHeader";
import SubNav from "./SubNav/SubNav";
import { fetchFormFieldData } from '@/assets/js/api.js';
import { dateToyymmddFormat } from '@/assets/js/utils.js';
import appsConfig from "./PageHeader/appsConfig.js";

export default {
  name: "Layout",
  components: {
    PageHeader,
    SubNav,
  },
  data() {
    return {
      visibleBanner: false
    }
  },
  
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let token = urlParams.get("token");
    let user = urlParams.get("user");

    if (token === null) {
      token = localStorage.getItem("accessToken", token);
      user = localStorage.getItem("user", user);
    }

    localStorage.setItem("accessToken", token);
    localStorage.setItem("user", user);

    this.$store.commit("setLoggedIn", true);
    this.$store.commit("setUser", user);
    this.$store.commit("setAccessToken", token);
    await fetchFormFieldData("User")
      .then(user => {
        this.setApplicationAccess(user.applications);
        localStorage.setItem("user", user.email);
        this.$store.commit("setUser", user.email);
        this.$store.commit(
            'systemInfo/updateInternalAndMMSOnly',
            user.internalAndMMSOnly,
          );
        for (let i = 0; i < user.applications.length; i++) {
          if (user.applications[i].applicationName == "online-analys") {
            this.$store.commit('systemInfo/updateFullAccess', true);
          }
          if (user.applications[i].applicationName == "online-analys-light") {
            this.$store.commit('systemInfo/updateLightAccess', true);
          }
          if (user.applications[i].applicationName == "online-analys-annonsör") {
            this.$store.commit('systemInfo/updateAdvertiserAccess', true);
          }
        }
      })
      .catch(error => {
        if (error.response?.status != 401)
          this.toastMessage(
            "A problem occurred while fetching user.",
            false
          );
        console.error(error);
      });

    //Fetch Message from api
      try {
        let messages = await fetchFormFieldData('Message')
        this.$store.commit(
            'systemInfo/updateObsMessage',
            messages.obsMessage,
          );
        this.$store.commit(
            'systemInfo/updateDataLogMessage',
            messages.dataLogMessage,
          );
      } catch (error) {
        if (error.response?.status != 401)
          this.toastMessage('A problem occurred while fetching messages.', false);
        console.error(error);
      }
     
    //Fetch Version from api
    await fetchFormFieldData('Information')
      .then((information) => {
        if (information.statusCode) {
          this.$bvToast.toast(information.errorMessage, {
            title: 'Warning',
            variant: 'warning',
            solid: true,
            autoHideDelay: 3000,
          });
        } else {
          information.lastImported = information.lastImported.slice(0, -3);
          information.lastProcessed = information.lastProcessed.slice(0, -3);
          information.latestDay = dateToyymmddFormat(information.latestDay);
          
          this.$store.commit(
            'systemInfo/updateSSASInfo',
            information,
          );
          this.$store.commit(
            'systemInfo/updateExcelExportFilePreName',
            information.excelExportFilePreName,
          );
          this.$store.commit(
            'systemInfo/updateExcelExportTextInFile',
            information.excelExportTextInFile,
          );

          this.$store.commit(
            'systemInfo/updatePublishedFromDate',
            dateToyymmddFormat(information.publishedFromDate),
          );
          this.$store.commit(
            'systemInfo/updatePublishedToDate',
            dateToyymmddFormat(information.publishedToDate),
          );
          this.$store.commit(
            'systemInfo/updateAdPublishedFromDate',
            dateToyymmddFormat(information.adPublishedFromDate),
          );
        }
      })
      .catch((error) => {
        if (error.response?.status != 401)
          this.toastMessage(
            'Problem fetching default dates from the server. The service will not function correctly.',
            true,
          );
        console.error(error);
      });
  },
  async mounted(){
    this.initializeBanner();
  },
  methods: {
    setApplicationAccess(applications) {
      let broadcastAccess =
        applications.filter(application =>
          application.applicationName.includes("tv-analys")
        ).length > 0;
      appsConfig.find(
        appConfig => appConfig.id == "broadcast"
      ).userAccess = broadcastAccess;
      let crossPlatformAccess =
        applications.filter(
          application => application.applicationName == "total-analys"
        ).length > 0;
      appsConfig.find(
        appConfig => appConfig.id == "cross-platform"
      ).userAccess = crossPlatformAccess;
      let videoInHomeAccess =
        applications.filter(
          application => application.applicationName == "video-in-home"
        ).length > 0;
      appsConfig.find(
        appConfig => appConfig.id == "video-in-home"
      ).userAccess = videoInHomeAccess;
    },
    toastMessage(message, closeButton) {
      if (closeButton) {
        const h = this.$createElement;

        const vNodesMsg = h('b', { class: ['text-center', 'mb-0'] }, [
          message,
          h(
            'b-button',
            {
              class: ['float-right', 'btn-sm', 'mr-3'],
              on: {
                click: () => this.$bvToast.hide('toast'),
              },
            },
            'Close',
          ),
        ]);

        this.$bvToast.toast([vNodesMsg], {
          id: 'toast',
          title: 'Warning',
          variant: 'danger',
          solid: true,
          noAutoHide: true,
        });
      } else {
        this.$bvToast.toast(message, {
          title: 'Warning',
          variant: 'warning',
          solid: true,
        });
      }
    },
      initializeBanner() {
      if (
        localStorage.getItem("browserBanner") == null &&
        !this.$browserDetect.isChrome
      )
      this.visibleBanner = true;
    },
    hideBrowserBanner() {
      localStorage.setItem("browserBanner", true);
      this.visibleBanner = false;
    },
  }
};
</script>
<style>
label,
button:not(.mx-btn) {
  float: left;
}
.vdpClearInput {
  margin-top: 20px;
}

.banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  border-radius: 0;
  background: #424851;
}

.browserWarning {
  color: red;
}

.browserBannerBtn{
  float:right;
  background: #97D058;
  border: none;
}
</style>
